var render, staticRenderFns
import script from "./AccessLevel.vue?vue&type=script&lang=js&"
export * from "./AccessLevel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6f7cd4",
  null
  
)

export default component.exports